/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M1.646 2.354l.708-.707 20 20-.708.706z"/><path pid="1" d="M1.646 21.646l20-20 .707.708-20 20z"/>'
  }
})
